let api_key = 'mRiz0K0QFFwiObBUW5NomKAsI97QnZF1bFp5FpdX'
export default api_key
